import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { getFormInitialValues } from 'redux-form'

export class PhoneVerification extends React.PureComponent {
  onClick = () => {
    this.props.onClick(this.props.index)
  }

  render () {
    const {isVerified} = this.props
    return (
      isVerified
        ? <div className='info-verifikacija info-verifikacija-mobilni info-verifikacija-true'>
          <p>Verifikovan mobilni broj</p>
        </div>
        : <div className='info-verifikacija info-verifikacija-mobilni2 info-verifikacija-false'>
          <a href='javascript:void(0)' onClick={this.onClick}>Verifikuj mobilni telefon</a>
        </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const props = {isVerified: false}
  const initValues = getFormInitialValues('update')(state)
  if (initValues.phones && Array.isArray(initValues.phones)) {
    const searchedPhone = initValues.phones.filter((item, index) => index === ownProps.index)
    if (searchedPhone.length) {
      props.isVerified = true
    }
  }
  return props
}

PhoneVerification.propTypes = {
  isVerified: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
}

PhoneVerification.defaultProps = {
  isVerified: false,
  index: 0
}

export default connect(mapStateToProps)(PhoneVerification)
